import axios from 'axios';
//samsung
export const errCheck = (err) => {
    if(err.response.data.statusCode=='401'){
        localStorage.removeItem("token");
        window.location.href = '/login';
    }
};
export default class JobSeekerService {
    // async getAdminList(name, email) {
    //     return await axios
    //         .post(`/api/v1/admin/user/admin-list`, {
    //             name: name,
    //             email: email,
    //         })
    //         .then((res) => res.data.data.user)
    //         .catch((err) => {
    //             errCheck(err);
    //         });
    // }
    async getJobSeekerList(data) {
        return await axios .post('/api/v1/admin/job-seeker/list', data);
    }
    async getUserListsingle(startdate) {
        return await axios.post(`/user`, { status: 'active', startDate: startdate }).then((res) => res.data.data.users).catch((err) => {
            errCheck(err);
        });
    }
    async viewJobSeeker(ids) {
        return await axios
            .post(`api/v1/admin/job-seeker/details`, {
                user_id: ids,
            })
            .then((res) => res.data.result);
    }
    
    async addAdmin(data) {
        return await axios.post(`/api/v1/admin/user/admin-add`, data).then((res) => res.data.data[0]);
    }
    async updateUser(ids, nick, nm, gend, ag_grp, marr_stat, stat, child, childList, pets, petType) {
        return await axios.patch(`/user/update`, { id: ids, nickname: nick, name: nm, gender: gend, age_group: ag_grp, married: marr_stat, status: stat, has_children: child, children: childList, has_pets: pets, pets: petType }).then((res) => res);
    }

    async deleteUser(id) {
        return await axios.delete(`/user/delete`, { deleteIdArray: id }).then((res) => res) .catch((err) => {
            errCheck(err);
        });
    }
    async viewUser(ids) {
        return await axios.get(`/user/${ids}`).then((res) => res.data);
    }
    async getExcel(nname,uname, hchild, agechild, gend, agGrp, marrStat,status,hpet, minPoint, maxPoint, sdate, edate,dreason) {
        return await axios({
            url: `/user/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                nickname: nname,
                username: uname,
                has_children: hchild,
                children_age: agechild,
                gender: gend,
                age_group: agGrp,
                marital_status: marrStat,
                status: status,
                has_pet: hpet,
                min_point: minPoint,
                max_point: maxPoint,
                start_date: sdate,
                end_date: edate,
                reason:dreason,
            },
        }).then((res) => res)
        .catch((err) => {
            errCheck(err);
        });
    }
    async getPointHistoryExcel(uid) {
        return await axios({
            url: `/user/points_history/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                user_id:uid
            },
        }).then((res) => res)
        .catch((err) => {
            errCheck(err);
        });
    }
    
}
